/**
 * Ключ підписки Web Push цього браузера (`push-device.ts`): синхронна частина першого екрана. Вихід
 * читає id рядка до будь-якого `import()` і ставить `DELETE` від натискання «Вийти»: вкладку можуть
 * закрити, поки лінивий модуль ще в дорозі, а `pagehide` стирає ключ (Should Security на #1357).
 */
export const PUSH_DEVICE_KEY = 'clientline.push.subscription';

export interface DevicePush {
  /** Id рядка `platform.push_subscriptions`. */
  id: string;
  /** Чий рядок; `null` — старий формат ключа (лише id), людини не знаємо. */
  user: string | null;
}

export function readDevicePush(): DevicePush | null {
  let raw: string | null;
  try {
    raw = localStorage.getItem(PUSH_DEVICE_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as { id?: unknown; user?: unknown } | null;
    if (typeof value?.id === 'string' && typeof value.user === 'string') {
      return { id: value.id, user: value.user };
    }
  } catch {
    // Старий формат — сам id рядка.
  }
  return { id: raw, user: null };
}
